export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DivisionSchema.vue?vue&type=template&id=4952806d&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Divisions/DivisionSchema.vue?vue&type=template&id=4952806d&scoped=true
// module id = 2541
// module chunks = 31